// extracted by mini-css-extract-plugin
export default {"navbar":"navigation_navbar__cKf69","links":"navigation_links__9YIsJ","mini":"navigation_mini__YNzeQ"};